import WAValidator from "multicoin-address-validator";

export function validateCoinAddress(address: string, network: string) {
  let isValid: boolean;
  try {
    isValid = WAValidator.validate(address, network);

    if (network === "AVAX" && !isValid) {
      // based on https://github.com/ava-labs/mastering-avalanche/blob/main/chapter_04.md
      isValid = /^([XPC]|[a-km-zA-HJ-NP-Z1-9]{36,72})-[a-zA-Z]{1,83}1[qpzry9x8gf2tvdw0s3jn54khce6mua7l]{38}$/.test(
        address,
      );
    }
  } catch (e) {
    console.error(e);
    isValid = /^(0x)[0-9A-Fa-f]{40}$/.test(address);
  }

  return isValid;
}
